import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import EndUserChatCometChatView from './end_user_chat_cometchat_view';
import EndUserChatNicknameConfig from './end_user_chat_nickname_config';
import EndUserChatJoining from './end_user_chat_joining';
import { chatLogInUser } from '../../features/end_user_chat/end_user_chat_slice';
import {
  useGetCurrentSpaceMembershipQuery,
  useGetEndUserSpaceQuery,
} from '../../app/smorgAppSyncGraphQLApiCustomHooks';
import { userDefaultFriendlyNameForChatSelector } from '../../features/user_id/user_id_slice';

const EndUserChatView = () => {
  const dispatch = useDispatch();

  const { data: currentSpaceMembership } = useGetCurrentSpaceMembershipQuery();

  const { data: currentSpace } = useGetEndUserSpaceQuery();

  const chatNickname = currentSpaceMembership?.chatNickname;

  const isChatInitialized = useSelector(
    (state) => !!state.endUserChat.chatAuthToken,
  );
  const hasChatNickname = !!chatNickname && chatNickname.length > 0;
  const defaultChatNickname = useSelector(
    userDefaultFriendlyNameForChatSelector,
  );
  const [joiningChat, setJoiningChat] = useState(false);

  useEffect(() => {
    if (isChatInitialized) {
      return;
    }
    if (
      !!chatNickname &&
      chatNickname.length > 0 &&
      currentSpaceMembership?.id &&
      currentSpace?.chatConfig?.appID &&
      currentSpace?.chatConfig?.appRegion
    ) {
      setJoiningChat(true);
      dispatch(
        chatLogInUser({
          appID: currentSpace?.chatConfig?.appID,
          appRegion: currentSpace?.chatConfig?.appRegion,
          chatNickname,
          spaceMembershipID: currentSpaceMembership?.id,
        }),
      ).finally(() => setJoiningChat(false));
    }
  }, [
    isChatInitialized,
    chatNickname,
    dispatch,
    currentSpaceMembership?.id,
    currentSpace?.chatConfig?.appID,
    currentSpace?.chatConfig?.appRegion,
  ]);

  if (!hasChatNickname) {
    return (
      <EndUserChatNicknameConfig defaultChatNickname={defaultChatNickname} />
    );
  }

  if (joiningChat) {
    return <EndUserChatJoining />;
  }

  return <EndUserChatCometChatView />;
};

export default EndUserChatView;
